<sp-alert type="info">
  Snippets are dynamic text blocks that change based on conditions like the time of day or a user's physical location.
</sp-alert>

<form class="replacement-component-select"></form>

<form class="snippet-fields"></form>
